(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('ApplicationsController', ApplicationsController);

    /** @ngInject */
    function ApplicationsController($scope, $rootScope, ApplicationService, AuthenticationService, HelperService, DATA_EVENTS) {
        const vm = this;

        vm.getApplicationImage = application => {
            return HelperService.imageResizePath('application', application.Id, application.Image, 200, 200);
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getApplications() {
            const selectedUnit = AuthenticationService.getSelectedUnit();

            HelperService.startLoading('.applications-holder');

            ApplicationService
                .getHighlighted(selectedUnit.ExternalCode)
                .then(success => {
                    vm.applications = success;
                    HelperService.stopLoading('.applications-holder');
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function init() {
            vm.applications = [];

            getApplications();
        }
    }
}());